export enum NFC_MINT_TYPES {
  OFFCHAIN = "OFFCHAIN",
  ONCHAIN = "ONCHAIN",
}
